import React from 'react';

import { StyledIcon } from '../StyledIcon';

export const FormClock = props => (
  <StyledIcon viewBox='0 0 24 24' a11yTitle='FormClock' {...props}>
    <path fill='none' stroke='#000' strokeWidth='2' d='M12,18 C15.3137085,18 18,15.3137085 18,12 C18,8.6862915 15.3137085,6 12,6 C8.6862915,6 6,8.6862915 6,12 C6,15.3137085 8.6862915,18 12,18 Z M12,8 L12,12 L15,13' />
  </StyledIcon>
);
